import { useEffect, useState } from 'react';

/** 12/06/2026 02:00 GMT+7 = 11/06/2026 19:00 UTC — đồng bộ SC88 */
const TARGET_TIME = Date.UTC(2026, 6, 20, 2, 0, 0);

const LABELS = [
  { key: 'days', label: 'NGÀY' },
  { key: 'hours', label: 'GIỜ' },
  { key: 'minutes', label: 'PHÚT' },
  { key: 'seconds', label: 'GIÂY' }
];

const calculateTimeLeft = () => {
  const now = Date.now();
  const diff = TARGET_TIME - now;

  if (diff <= 0) {
    return {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
      finished: true
    };
  }

  const totalSeconds = Math.floor(diff / 1000);
  const days = Math.floor(totalSeconds / (24 * 60 * 60));
  const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (n) => n.toString().padStart(2, '0');

  return {
    days: pad(days),
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
    finished: false
  };
};

/**
 * Bốn ô đếm ngược — Figma:
 * - Mobile (< md): 95:435 — 40×40, bo 6px, gap 4px, số 18px, nhãn 10px
 * - md+: 95:399 (64×64, bo 8px, gap 8px, số 28px / nhãn 12px)
 */
const CountDownFinal = () => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, []);

  // if (timeLeft.finished) {
  //   return (
  //     <div
  //       className="inline-flex shrink-0 flex-col items-center justify-center rounded-lg border-2 border-[#26A9E0]/50 bg-white/95 px-3 py-2 shadow-md"
  //       style={{ fontFamily: 'Roboto, sans-serif' }}
  //     >
  //       <span className="text-center text-xs font-bold uppercase tracking-wide text-[#0B85C7] md:text-sm">
  //         Vòng chung kết đang diễn ra
  //       </span>
  //     </div>
  //   );
  // }

  const values = {
    days: timeLeft.days,
    hours: timeLeft.hours,
    minutes: timeLeft.minutes,
    seconds: timeLeft.seconds
  };

  return (
    <div
      className="flex shrink-0 items-center gap-1 md:gap-2"
      role="timer"
      aria-live="polite"
      aria-label="Đếm ngược đến World Cup 2026"
    >
      {LABELS.map(({ key, label }) => (
        <div
          key={key}
          className="flex h-10 w-10 flex-col items-center justify-center rounded-md p-1 text-center text-white shadow-sm md:h-16 md:w-16 md:rounded-lg md:p-1"
          style={{
            fontFamily: 'Roboto, sans-serif',
            background: 'linear-gradient(180deg, #26A9E0 0%, #0B85C7 100%)'
          }}
        >
          <span className="text-lg font-black leading-none md:text-[28px]">{values[key]}</span>
          <span className="mt-px text-[10px] font-bold uppercase leading-none md:text-xs">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default CountDownFinal;
